import React from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { Grid } from '@mui/material';
import AutoCompleteComponent from '../../component/Autocomplete';
import PageFilter from '../../component/PageFilter';


const AddressModal = ({
    open,
    onClose,
    options,
    autoCompleteName,
    sheetFilter,
    handleSheetFilter,
    handleModalSubmit,
    autoCompleteLoading, 
    autoCompleteOptions,
    handleChangeAutoComplete,
    handleSearchValueAutoComplete
}) => {
    return (
        <Dialog closeAfterTransition={false} fullWidth maxWidth={'md'} open={open} onClose={onClose}>
            <DialogTitle>Select Address </DialogTitle>
            <DialogContent>
                <Grid container direction="row" spacing={2}>
                    <Grid item xs={12} sm={6} md={6}>
                        <PageFilter
                            options={options}
                            //width={100}
                            filterValue={sheetFilter}
                            handleSheetFilter={handleSheetFilter} 
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                        <AutoCompleteComponent 
                            name={autoCompleteName}
                            label="Search Text"
                            options={autoCompleteOptions}
                            loading={autoCompleteLoading}
                            handleSearchValueAutoComplete={handleSearchValueAutoComplete}
                            handleChangeAutoComplete={handleChangeAutoComplete}
                        />
                    </Grid> 
                </Grid>        
            </DialogContent>
            <DialogActions>
                <Button 
                    variant="contained"
                    size="medium"
                    color="primary" 
                    onClick={handleModalSubmit}
                >Submit</Button>
                <Button 
                    variant="contained"
                    size="medium"
                    color="error" 
                    onClick={onClose}
                >Close</Button>
            </DialogActions>
        </Dialog>
    )
}

export default AddressModal